import scrollTo from "./lenis";

export default function ServicesScrollTo() {

    const currentURL = window.location.href;

    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    if (currentURL.indexOf("?ID") !== -1 && $('.c-collapse').length > 0) {

        setTimeout(function () {

            const ID = getParameterByName("ID", currentURL);
            const $target = document.getElementById(ID);

            scrollTo({
                target: $target,
                options: {
                    lerp: 0,
                    duration: 0,
                    offset: -150
                }
            });

            if ($('.c-collapse').length > 0) {
                $($target).addClass('js-isActive');
                $($target).find('svg').addClass('js-isActive');
                $($target).find('.c-collapse__item--content').slideDown(0);
                TweenMax.to($($target).find('svg'), 0, {rotation: 45, ease: Power2.easeInOut});
                $($target).find('.c-collapse__item--btn').removeClass('js-isActive');
            }

        }, 100);
    } else {
        setTimeout(function () {
            scrollTo({
                target: 'top',
                options: {
                    lerp: 0,
                    duration: 0
                }
            });
        }, 100)
    }
}

$(document).ready(function () {
    ServicesScrollTo();
});
